import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "component-contents" }
const _hoisted_2 = { class: "message-part" }
const _hoisted_3 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_4 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_5 = { class: "reply-option-add" }
const _hoisted_6 = { class: "field is-horizontal" }
const _hoisted_7 = { class: "field-body" }
const _hoisted_8 = { class: "control" }
const _hoisted_9 = {
  key: 0,
  class: "help is-danger"
}
const _hoisted_10 = {
  key: 1,
  class: "help is-danger"
}

import Draggable from 'vuedraggable';
import { nanoid } from 'nanoid';
import { FlowViewModel, InputVariableViewModel, StateViewModel } from '@/features/bots/models/designer';
import QuickReplyOption from './QuickReplyOption.vue';
import IslandBadge from './IslandBadge.vue';
import AdditionalInformationWrapper from './AdditionalInformationWrapper.vue';
import InputValidationConfig from './InputValidationConfig.vue';
import VariablePicker from './VariablePicker/VariablePicker.vue';
import ChevronRight from 'vue-material-design-icons/ChevronDoubleRight.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import AddIcon from 'vue-material-design-icons/PlusCircle.vue';
import ErrorIcon from 'vue-material-design-icons/AlertCircleOutline.vue';
import TextEditor from '@/features/bots/components/designer/TextEditor/TextEditor.vue';
import { TransitionViewModel } from '@/features/bots/models/designer/transitionViewModel';
import { RegexType } from '../../models/designer/regexType';
import { FlowStatus } from '@/features/bots/models/flowStatus';
import { LOAD_FLOWS } from '@/store/bot-designer/actionTypes';
import { FlowListItemViewModel } from '@/features/bots/models/flowListItemViewModel';
import { computed, onMounted, PropType, ref, watch } from 'vue';
import { useStore } from 'vuex';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import VuelidateUtil from '@shared/util/vuelidateUtil';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuickReplyComponent',
  props: {
  value: {
    type: Object as PropType<StateViewModel>,
    required: true,
  },
},
  emits: ["state-updated"],
  setup(__props, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

__expose({
  focusOnInput,
});

const store = useStore();
const doesAttributeExist = (attributeId: string) =>
  computed<boolean>(() => store.getters.doesAttributeExist(attributeId));
const isAttributeArchived = (attributeId: string) =>
  computed<boolean>(() => store.getters.isAttributeArchived(attributeId));
const currentFlow = computed<FlowViewModel>(() => store.getters.currentFlow);
const loadFlows = (doLoad = false): Promise<FlowListItemViewModel[]> => store.dispatch(LOAD_FLOWS, doLoad);

const showConfig = ref(false);
const hasClicked = ref(false);
const transition = ref('display');
const flows = ref<FlowListItemViewModel[]>([]);
const textEditor = ref<typeof TextEditor | null>(null);
const state = ref<StateViewModel>({
  id: '',
  component: 'InputString',
  allowedAttempts: 1,
  options: [],
});
const additionalConfigInvalid = ref(false);

const validations = computed(() => ({
  state: {
    text: {
      required,
    },
    options: {
      required,
    },
    storedVariable: {
      attributeMissing(value: InputVariableViewModel) {
        const storedVar: InputVariableViewModel = state.value.storedVariable;
        return !storedVar || storedVar.scope !== 'appUser.customAttributes' || doesAttributeExist(storedVar.key).value;
      },
      attributeArchived(value: InputVariableViewModel) {
        return !isArchived();
      },
    },
  },
}));

const $v = useVuelidate(validations, { state });
const isTextRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.state.text));
const isOptionsRequiredInvalid = computed(() => VuelidateUtil.isRequiredInvalid($v, (v) => v.state.options));
const isAttributeMissingInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.state.storedVariable, 'attributeMissing'),
);
const isAttributeArchivedInvalid = computed(() =>
  VuelidateUtil.isValidationInvalid($v, (v) => v.state.storedVariable, 'attributeArchived'),
);

onMounted(() => loadFlows());

watch(
  () => props.value,
  () => {
    try {
      state.value = props.value;
      updateValidation();
    } catch (err: any) {
      console.error('DME watch(() => props.value', err);
    }
  },
  { immediate: true },
);

function textUpdated(text: string) {
  if (state.value.text === text) {
    return;
  }

  state.value.text = text;

  if ($v.value.state && $v.value.state.text) {
    $v.value.state.text.$touch();
  }

  updateState();
}

function updateOptionTransition(index: number, updatedOptionTransition: TransitionViewModel) {
  if (!state.value.options) {
    return;
  }

  if (state.value.options[index]) {
    state.value.options[index].transition = updatedOptionTransition;
  }
  updateState();
}

function addOption() {
  if (!state.value.options) {
    state.value.options = [];
  }

  if (!canAddMoreOptions()) {
    return;
  }

  state.value.options.push({
    id: `opt-${nanoid(7)}`,
    text: '',
  });

  updateState();
}

function deleteOption(optionIndex: number) {
  if (!state.value.options) {
    return;
  }
  state.value.options.splice(optionIndex, 1);

  updateState();
}

function setClickedState() {
  hasClicked.value = true;
}

function setUnclickedState() {
  hasClicked.value = false;
  showConfig.value = false;
  transition.value = 'display';

  $v.value.$touch();
}

function showExpandedConfig() {
  hasClicked.value = true;
  showConfig.value = true;
  transition.value = 'none';
}

function hideExpandedConfig() {
  showConfig.value = false;
}

function optionUpdated(optionIndex: number, text: string) {
  if (!state.value.options) {
    return;
  }

  if (!stateOptionHasBeenUpdated(optionIndex, text)) {
    return;
  }

  state.value.options[optionIndex].text = text;
  updateState();
}

function additionalConfigChanged(updatedState: StateViewModel, invalid: boolean) {
  state.value = updatedState;
  additionalConfigInvalid.value = invalid;
  updateState();
}

function variableSelected(variable: InputVariableViewModel) {
  state.value.storedVariable = variable;
  if (state.value.storedVariable.dataType === 'decimal') {
    state.value.pattern = RegexType.DECIMAL;
  } else if (state.value.storedVariable.dataType === 'number') {
    state.value.pattern = RegexType.NUMERIC;
  } else if (isAppUserPhoneNumber()) {
    state.value.pattern = RegexType.PHONE_NUMBER;
  } else if (isAppUserEmail()) {
    state.value.pattern = RegexType.EMAIL;
  } else {
    state.value.pattern = '';
  }
  state.value.allowedAttempts = 1;
  state.value.errorMessage = '';

  updateState();
}

function canAddMoreOptions() {
  return state.value.options && state.value.options.length < 10;
}

function getAddTooltipText() {
  if (!canAddMoreOptions()) {
    return 'You can only display a maximum of 10 options';
  }
  return '';
}

function getDataTypeErrorMessage() {
  if (state.value && state.value.storedVariable && state.value.storedVariable.dataType) {
    if (state.value.storedVariable.dataType === 'decimal') {
      return 'decimal to 2DP';
    } else if (isAppUserPhoneNumber()) {
      return 'phone number';
    } else if (isAppUserEmail()) {
      return 'email';
    }
    return state.value.storedVariable.dataType;
  }
  return '';
}

function isValidTransition(transition: TransitionViewModel): boolean {
  if (currentFlow.value.status === FlowStatus.Live) {
    const flow = flows.value.find((f: FlowListItemViewModel) => f.id === transition.payload);
    if (flow && flow.status !== FlowStatus.Live) {
      return false;
    }
  }
  return true;
}

function isArchived(): boolean {
  if (state.value && state.value.storedVariable) {
    return isAttributeArchived(state.value.storedVariable!.key).value;
  }
  return false;
}

function focusOnInput() {
  textEditor.value?.focusElement();
  textEditor.value?.startEditing();
}

function hasDataType(): boolean {
  return !!(state.value && state.value.storedVariable && state.value.storedVariable.dataType);
}

function stateOptionHasBeenUpdated(optionIndex: number, value: string) {
  if (state.value && state.value.options && state.value.options[optionIndex]) {
    return state.value.options[optionIndex].text !== value;
  }
  return false;
}

function updateState() {
  updateValidation();
  emit('state-updated', state.value);
}

function updateValidation() {
  state.value.invalid = additionalConfigInvalid.value || $v.value.$invalid;
}

function isAppUserPhoneNumber() {
  return (
    state.value.storedVariable &&
    state.value.storedVariable.scope === 'appUser' &&
    state.value.storedVariable.key === 'phoneNumber'
  );
}

function isAppUserEmail() {
  return (
    state.value.storedVariable &&
    state.value.storedVariable.scope === 'appUser' &&
    state.value.storedVariable.key === 'email'
  );
}

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "quickreply-component",
    onClick: setClickedState
  }, [
    _createVNode(IslandBadge, {
      type: "quickreply",
      draggable: false
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(TextEditor, {
          ref_key: "textEditor",
          ref: textEditor,
          value: state.value.text,
          placeholder: 'Enter a message...',
          onTextUpdated: textUpdated
        }, null, 8, ["value"]),
        (isTextRequiredInvalid.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Message text must not be empty"))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_unref(Draggable), {
        modelValue: state.value.options,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.value.options) = $event)),
        class: "reply-options-list",
        "item-key": "id"
      }, {
        item: _withCtx(({ element: option, index }) => [
          (_openBlock(), _createBlock(QuickReplyOption, {
            key: option.id,
            option: option,
            index: index,
            "all-options": state.value.options,
            pattern: state.value.pattern,
            "data-type-error-message": getDataTypeErrorMessage(),
            "has-data-type": hasDataType(),
            "is-valid-transition": isValidTransition,
            onTextUpdated: optionUpdated,
            onTransitionSelected: updateOptionTransition,
            onDeleteOption: deleteOption
          }, null, 8, ["option", "index", "all-options", "pattern", "data-type-error-message", "has-data-type"]))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (isOptionsRequiredInvalid.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Must have at least one option"))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_n_tooltip, {
          text: getAddTooltipText()
        }, {
          default: _withCtx(() => [
            _createElementVNode("a", {
              onClick: addOption,
              class: _normalizeClass(["add-button", { disabled: !canAddMoreOptions() }])
            }, [
              _createVNode(AddIcon, { class: "icon-1-3x" })
            ], 2)
          ]),
          _: 1
        }, 8, ["text"])
      ]),
      _withDirectives(_createVNode(AdditionalInformationWrapper, {
        color: "#FF6666",
        "text-color": "#FFFFFF"
      }, {
        content: _withCtx(() => [
          _createVNode(InputValidationConfig, {
            value: state.value,
            fields: ['errorMessage', 'allowedAttempts', 'noMatch'],
            onUpdated: additionalConfigChanged
          }, null, 8, ["value"]),
          _createElementVNode("fieldset", null, [
            _createElementVNode("div", _hoisted_6, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "field-label" }, [
                _createElementVNode("label", { class: "label" }, "Store result")
              ], -1)),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(VariablePicker, {
                    value: state.value.storedVariable,
                    onVariableSelected: variableSelected
                  }, null, 8, ["value"]),
                  (isAttributeMissingInvalid.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_9, "Attribute does not exist"))
                    : _createCommentVNode("", true),
                  (isAttributeArchivedInvalid.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_10, "Attribute has been archived"))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]),
        _: 1
      }, 512), [
        [_vShow, showConfig.value]
      ]),
      _createVNode(_Transition, { name: transition.value }, {
        default: _withCtx(() => [
          (hasClicked.value && !showConfig.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "expander",
                onClick: showExpandedConfig
              }, [
                _createVNode(ChevronRight, { class: "chevron" })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["name"]),
      (hasClicked.value && showConfig.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "expander",
            onClick: hideExpandedConfig
          }, [
            _createVNode(ChevronLeft, { class: "chevron" })
          ]))
        : _createCommentVNode("", true),
      (state.value.invalid && !showConfig.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass(["invalid-warning", { 'shift-for-expander': hasClicked.value }])
          }, [
            _createVNode(ErrorIcon, { class: "icon-1-3x" })
          ], 2))
        : _createCommentVNode("", true)
    ])
  ])), [
    [_directive_click_away, setUnclickedState]
  ])
}
}

})